"use client";
import { NEWSLETTER_SIGNUP_PAGE_VIEWED } from "@/constants/amplitude";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import useOnce from "@/utils/hooks/useOnce";

const NewsletterPageViewClient = () => {
  const { logAmplitudeEvent, setPage } = useAmplitude();
  useOnce(() => {
    setPage("newsletter_signup");
    logAmplitudeEvent(NEWSLETTER_SIGNUP_PAGE_VIEWED);
  });
  return null;
};
export default NewsletterPageViewClient;
